export default __webpack_public_path__ + "static/media/mercado-pago-logo.f144d370.png";